import React, { useEffect, useRef } from 'react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import './Services.css';

gsap.registerPlugin(ScrollTrigger);

const services = [
  {
    id: '01',
    title: 'Stampa 3D',
    desc: 'Prototipi, oggetti personalizzati e produzioni in serie. FDM, resin e SLA per ogni esigenza.',
    icon: '⬡',
    color: '#bf00ff',
    tags: ['FDM', 'Resina', 'SLA', 'Prototipazione'],
  },
  {
    id: '02',
    title: 'Incisione Laser',
    desc: 'Incisioni di precisione su legno, metallo, vetro, pelle e molto altro con risultati professionali.',
    icon: '◈',
    color: '#00ccff',
    tags: ['Legno', 'Metallo', 'Vetro', 'Pelle'],
  },
  {
    id: '03',
    title: 'Stampa UV',
    desc: 'Stampa UV su qualsiasi superficie. Colori brillanti, texture tattili e finiture premium.',
    icon: '◉',
    color: '#ff00aa',
    tags: ['Flatbed', 'Texture', 'CMYK+W', 'Premium'],
  },
  {
    id: '04',
    title: 'Sviluppo Tech',
    desc: 'Siti web, applicazioni e soluzioni digitali su misura. Dal concept al deployment.',
    icon: '⟨⟩',
    color: '#00ff88',
    tags: ['Web', 'App', 'AI', 'Automazione'],
  },
  {
    id: '05',
    title: 'Design Digitale',
    desc: 'Brand identity, UI/UX e grafica professionale per distinguersi nel mercato.',
    icon: '✦',
    color: '#ffaa00',
    tags: ['Branding', 'UI/UX', 'Motion', 'Print'],
  },
  {
    id: '06',
    title: 'Prototipazione',
    desc: 'Dal concept al prototipo funzionante. Iteriamo velocemente per trovare la soluzione perfetta.',
    icon: '◎',
    color: '#bf00ff',
    tags: ['Concept', 'Rapid', 'Testing', 'Iterazione'],
  },
];

const Services: React.FC = () => {
  const sectionRef = useRef<HTMLElement>(null);
  const titleRef = useRef<HTMLDivElement>(null);
  const cardsRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    gsap.fromTo(titleRef.current,
      { y: 60, opacity: 0 },
      {
        y: 0, opacity: 1, duration: 1, ease: 'power3.out',
        scrollTrigger: { trigger: titleRef.current, start: 'top 80%' }
      }
    );

    const cards = cardsRef.current?.querySelectorAll('.service-card');
    cards?.forEach((card, i) => {
      gsap.fromTo(card,
        { y: 80, opacity: 0 },
        {
          y: 0, opacity: 1, duration: 0.8, ease: 'power3.out',
          delay: i * 0.1,
          scrollTrigger: { trigger: card, start: 'top 85%' }
        }
      );
    });
  }, []);

  return (
    <section id="services" className="services" ref={sectionRef}>
      <div className="section-bg-line" />
      <div className="container">
        <div className="section-header" ref={titleRef}>
          <span className="section-tag">— Cosa facciamo</span>
          <h2 className="section-title">
            I nostri <span className="highlight">servizi</span>
          </h2>
          <p className="section-desc">
            Dalla progettazione alla realizzazione, offriamo soluzioni complete
            per ogni esigenza creativa e tecnologica.
          </p>
        </div>

        <div className="services-grid" ref={cardsRef}>
          {services.map((s) => (
            <div className="service-card" key={s.id} style={{ '--accent': s.color } as any}>
              <div className="card-number">{s.id}</div>
              <div className="card-icon" style={{ color: s.color }}>{s.icon}</div>
              <h3 className="card-title">{s.title}</h3>
              <p className="card-desc">{s.desc}</p>
              <div className="card-tags">
                {s.tags.map(t => (
                  <span key={t} className="card-tag">{t}</span>
                ))}
              </div>
              <div className="card-arrow">→</div>
              <div className="card-border" />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
